import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {  EmpDetailsReportAndDashboard, Header } from '@aptsi-types';
import { DigitalIdentityReportService } from './reports.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { generateAccessiblePatterns } from 'src/app/shared/chart-patterns/chart-patterns';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {


      organizationEmployeeSummaryReport: EmpDetailsReportAndDashboard[] = [];
      digitalIdentityAssignmentReport: EmpDetailsReportAndDashboard[]= [];
      transferProvenanceReport: EmpDetailsReportAndDashboard[] = [];
      chartdata: EmpDetailsReportAndDashboard[] = [];
      sanitizedPdfUrl: SafeResourceUrl | null = null; // To hold the sanitized URL for viewing
      isView: boolean = false;
    
      constructor(
        private digitalIdentityReportService: DigitalIdentityReportService,
        private sanitizer: DomSanitizer // To sanitize the generated Blob URL
      ) {}

      filterOptions = [
        { label: 'Last 7 Days', value: 'last_7_days' },
        { label: 'Last Month', value: 'last_month' },
        { label: 'All Time', value: 'all_time' }
      ];
    
      selectedFilter: string = 'all_time'  

       headers: { header_1: Header[]; header_2: Header[]; header_3: Header[]  } = {
     
             header_1: [
               {
                 name: "Organization Id",
                 property: "organizationId"
               },
               {
                 name: "Organization Name",
                 property: "organizationName"
               },
               {
                 name: "Total Employees",
                 property: "totalEmployees"
               },
               {
                 name: "Active Employees",
                 property: "activeEmployees"
               }
             ],
           

             header_2: [
           
               {
                 name: "Digital Id",
                 property: "digitalId"
               },
               {
                 name: "Employee Id",
                 property: "employeeId"
               },
               {
                 name: "Organization Name",
                 property: "organizationName"
               },
               {
                 name: "Employee Name",
                 property: "employeeName"
               },
               {
                 name: "Organizational Unit",
                 property: "organizationalUnit"
               },
               {
                 name: "Assignment Date",
                 property: "assignmentDate"
               }
             ],
           
           
             header_3: [
               {
                 name: "Digital Id",
                 property: "digitalId"
               },
               {
                 name: "Employee Name",
                 property: "employeeName"
               },
             
               {
                 name: "Previous Organization",
                 property: "previousOrganization"
               },
             
               {
                 name: "Current Organization",
                 property: "currentOrganization"
               },
             
               {
                 name: "User Responsible",
                 property: "userResponsible"
               },
               {
                 name: "Transfer Date",
                 property: "transferDate"
               }
             ]
           
           };


          
    async ngOnInit(): Promise<void> {
      this.fetchReportData();
      this.fetchChartData();
    }

    chartData: any = {};

    async fetchChartData(filter?: string) {
      try {
          if (filter) {
                this.selectedFilter = filter;
              }
          this.chartData= [];
          
        const response = await this.digitalIdentityReportService.getDiChartData(this.selectedFilter).toPromise();
        console.log('DI chart response:', response);
  
        // Assuming the structure is correct, updating the mapping to reflect the correct keys
        this.chartdata = response["organizationWiseEmployeeDistributionDTO"];
        console.log('DI chart data:', this.chartdata);
  
        this.chartData = {
  labels: this.chartdata.map(item => item.organizationName),
  datasets: [
    {
      label: 'Active',
      data: this.chartdata.map(item => item.activeEmployees),
      backgroundColor: generateAccessiblePatterns(1)[0], // patterned fill
    },
    {
      label: 'Terminated',
      data: this.chartdata.map(item => item.terminatedEmployees),
      backgroundColor: generateAccessiblePatterns(2)[1], // patterned fill
    },
    {
      label: 'Retired',
      data: this.chartdata.map(item => item.retiredEmployees),
      backgroundColor: generateAccessiblePatterns(3)[2], // patterned fill
    }
  ]
};

      } catch (error) {
        console.error('Error fetching chart data:', error);
      }
    }

      // Chart options (Stacked Bar Chart)
  chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Organization',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of Employees',
        },
        min: 0,
        stacked: false,  // Enable stacking for bars
      },
    },
  };
  

   

      async fetchReportData(filter?: string) {
          try {
                 if (filter) {
        this.selectedFilter = filter;
      }
             this.organizationEmployeeSummaryReport = [];
             this.digitalIdentityAssignmentReport = [];
             this.transferProvenanceReport = [];
  //     console.log('Fetching data for:', this.selectedFilter);
  
            const response = await this.digitalIdentityReportService.getDiReports(this.selectedFilter).toPromise();
            
            this.organizationEmployeeSummaryReport = response["organizationEmployeeSummaryReportDTO"];
            this.digitalIdentityAssignmentReport = response["digitalIdentityAssignmentReportDTO"];
            this.transferProvenanceReport = response["transferProvenanceReportDTO"];
          } catch (error) {
            console.error('Error fetching report data:', error);
          }
        }
      

        async generateAndDownloadPDF() {
    await this.fetchReportData();

    if (!this.hasReportData) {
      return;
    }

    const doc = this.createPDFDocument(
      this.organizationEmployeeSummaryReport,
      this.digitalIdentityAssignmentReport,
      this.transferProvenanceReport
    );

    doc.save("AssetManagementReport.pdf");
  }

  async generateAndViewPDF() {
    await this.fetchReportData();

    if (!this.hasReportData) {
      return;
    }

    const doc = this.createPDFDocument(
      this.organizationEmployeeSummaryReport,
      this.digitalIdentityAssignmentReport,
      this.transferProvenanceReport
    );

    const pdfBlob = doc.output("blob");
    const pdfBlobUrl = URL.createObjectURL(pdfBlob);

    this.sanitizedPdfUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(pdfBlobUrl);

    this.isView = true;
  }

  get hasReportData(): boolean {
    return (
      this.organizationEmployeeSummaryReport?.length > 0 ||
      this.digitalIdentityAssignmentReport?.length > 0 ||
      this.transferProvenanceReport?.length > 0
    );
  }
      
        close(){
          this.isView=!this.isView;
        }
      
        private createPDFDocument(organizationEmployeeSummaryReport: EmpDetailsReportAndDashboard[], digitalIdentityAssignmentReport:EmpDetailsReportAndDashboard[], transferProvenanceReport: EmpDetailsReportAndDashboard[],) {
          const doc = new jsPDF();
      
          // Add title
          doc.setFontSize(18);
          doc.text('Digital Identity Report', 14, 10);

             // Add spacing
       doc.setFontSize(14);
       doc.text('Organization Employee Summary', 14, 20); 
      
          // Prepare table data
          const tableData1 = organizationEmployeeSummaryReport.map((item) => [
            item.organizationId,
            item.organizationName,           
            item.totalEmployees,
            item.activeEmployees,
          ]);

      
          // Add the table to the PDF
          (doc as any).autoTable({
            startY: 25,
            head: [['Organization Id', 'Organization Name', 'Total Employees', 'Active Employees']],
            body: tableData1,
            theme: 'striped',
            headStyles: { fillColor: [40, 78, 120], textColor: 255 },
            styles: { fontSize: 10 },
          });
      
      
          doc.addPage();
          doc.setFontSize(14);
          doc.text('Digital Identity Assignment', 14, 20); 
      
          // Prepare table data
          const tableData2 = digitalIdentityAssignmentReport.map((item) => [
            item.digitalId,
            item.employeeId,
            item.organizationName,
            item.employeeName,
            item.organizationalUnit,
            item.assignmentDate,
          ]);
      
          // Add the table to the PDF
          (doc as any).autoTable({
            startY: 25,
            head: [['Digital Id', 'Employee Id','Organization Name', 'Employee Name', 'Organizational Unit', 'assignmentDate']],
            body: tableData2,
            theme: 'striped',
            headStyles: { fillColor: [40, 78, 120], textColor: 255 },
            styles: { fontSize: 10 },
          });
      
          doc.addPage();
          doc.setFontSize(14);
          doc.text('Transfer Provenance', 14, 20); 

          // Prepare table data
          const tableData3 = transferProvenanceReport.map((item) => [
            
            item.digitalId,
            item.employeeName,
            item.previousOrganization,
            item.currentOrganization,
            item.userResponsible,
            item.transferDate
          ]);
      
          // Add the table to the PDF
          (doc as any).autoTable({
            startY: 25,
            head: [[ 'Digital Id','Employee Name', 'Previous Organization','Current Organization', 'Responsible User', 'Transfer Date']],
            body: tableData3,
            theme: 'striped',
            headStyles: { fillColor: [40, 78, 120], textColor: 255 },
            styles: { fontSize: 10 },
          });
      
          return doc; // Return the jsPDF document object
        }
}
